import * as React from 'react';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { UniDriverFactory } from '@wix/wix-ui-test-utils/uni-driver-factory';

export interface DropdownBaseUniDriver extends BaseUniDriver {
  getListType: (dataHook: string) => Promise<string>;
  clickTargetElement: (dataHook: string) => Promise<void>;
  hoverTargetElement: (dataHook: string) => Promise<void>;
  isDropdownShown: () => Promise<boolean>;
  selectOption: (index: string | number) => Promise<void>;
  selectOptionByDataHook: (dataHook: string) => Promise<void>;
  clickOutside: () => boolean;
  optionsCount: () => Promise<number>;
  mouseEnter: () => Promise<void>;
  mouseLeave: () => Promise<void>;
  optionContentAt: (id: number) => Promise<React.ReactNode>;
  getSelectedOptionId: () => Promise<string | null>;
  getMarkedOption: () => Promise<string | null>;
}

declare const dropdownBaseDriverFactory: UniDriverFactory<DropdownBaseUniDriver>;
